import { createContext, Dispatch, SetStateAction } from "react";
import { GetUnreadNotificationCountResponse } from "../../api/dtos/dtos";

/**
 * --- Interfaces ---
 */
export interface INotificationContext {
    totalCount: number | undefined,
    setTotalCount: Dispatch<SetStateAction<number | undefined>>;
    refresh: () => Promise<GetUnreadNotificationCountResponse | undefined>;
}

/**
 * --- Notification Context ---
 */
export const NotificationContext = createContext<INotificationContext>({
    totalCount: undefined,
    setTotalCount: () => {},
    refresh: async () => { return undefined },
});